<div *ngIf="showDonut" class="card flex-row justify-content-start mobile" style="background: none; border: none">
    <div class="gbo_shadow" style="border-right: 1px ridge #E3E8F0; background: white">
        <p-chart #donut (click)="updateDonut(donut)" [data]="donutData"
                 [height]="'250'" [options]="options" [responsive]="false"
                 [width]="deviceWidth > 800 ? '310' : (deviceWidth - 50).toString()"
                 type="doughnut"></p-chart>
    </div>
    <div class="gbo_shadow donut_info">
        <h1 class="donut_total_info">
            <div class="total-free-title"
                 title="Расчитывается по формуле: Общий баланс + Аккредитивы поступления - Аккредитивы оплаты">
                {{ getProjectTotal() | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
                <small style="font-size: 12px; vertical-align: super;">* с учетом ожидаемых</small></div>
        </h1>
        <h5 class="donut_all_total">
            <label>На счетах:</label>
            <strong>{{ allTotal | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}</strong>
        </h5>

        <div class="row">
            <div class="col-6">
                <ul class="list-payments">
                    <li class="head"><h2>Аккредитив поступления</h2></li>
                    <li (click)="hideChart(donut, 0)" [style]="hideDonutData[0] ? 'text-decoration: line-through;' : ''"
                        class="in_promised"
                        data-action="hide0"
                        style="cursor: pointer"
                    >
                        Подтвержденные:
                        + {{ donutData.datasets[0].data[0] | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
                    </li>
                    <li (click)="hideChart(donut, 1)" [style]="hideDonutData[1] ? 'text-decoration: line-through;' : ''"
                        class="in_expected"
                        data-action="hide1"
                        style="cursor: pointer"
                    >
                        Ожидаемые: + {{ donutData.datasets[0].data[1] | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
                    </li>
                </ul>
            </div>
            <div class="col-6">
                <ul class="list-payments">
                    <li class="head"><h2>Аккредитив оплата</h2></li>
                    <li (click)="hideChart(donut, 2)" [style]="hideDonutData[2] ? 'text-decoration: line-through;' : ''"
                        class="out_promised"
                        data-action="hide2"
                        style="cursor: pointer"
                    >
                        Подтвержденные:
                        - {{ donutData.datasets[0].data[2] | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
                    </li>
                    <li (click)="hideChart(donut, 3)" [style]="hideDonutData[3] ? 'text-decoration: line-through;' : ''"
                        class="out_expected"
                        data-action="hide3"
                        style="cursor: pointer"
                    >
                        Ожидаемые:
                        - {{ donutData.datasets[0].data[3] | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>